import EmployeeSalaryComponents from "../components/EmployeeSalary";
import useEmployeeSalary from "../hooks/useEmployeeSalary";

function EmployeeSalary() {
  const employeeSalaryProps = useEmployeeSalary();
  return <EmployeeSalaryComponents {...employeeSalaryProps} />;
}

export default EmployeeSalary;
